import { KYMW6802Model } from '../kymw6802.model';
import { SaveCWSCategoryConvListModel } from '../vo/save-cws-category-conv-list.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';


/**
 * CWSカテゴリ変換マスタ一覧出力のDelegateクラス
 *
 * @export API通信成功時の処理
 * @class SaveCwsCategoryConvListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class SaveCwsCategoryConvListService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: KYMW6802Model;
  private successFunc: Function;
  private vo: SaveCWSCategoryConvListModel;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof SaveCwsCategoryConvListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        CategoryDiv: this.vo.categoryDiv,
        ConvDiv: this.vo.convDiv,
        CategoryCode: this.vo.categoryCode,
        ClassCode: this.vo.classCode,
        LargeClassCode: this.vo.largeClassCode,
        MiddleClassCode: this.vo.middleClassCode,
        SmallClassCode: this.vo.smallClassCode,
        MarkCode: this.vo.markCode,
        PricePattern: this.vo.pricePattern,
        MediumType: this.vo.mediumType,
        FeatureCode: this.vo.featureCode,
        PageNum: this.vo.pageNum,
        PromotionDiv: this.vo.promotionDiv,
        PromotionInfo: this.vo.promotionInfo,
        ExhibitionDiv: this.vo.exhibitionDiv,
        Tag1: this.vo.tag1,
        Tag2: this.vo.tag2,
      }
    })
  }

  /**
   * API呼び出し
   *
   * @param {KYMW6802Model} model
   * @param {string} orderCode
   * @param {string} categoryLevel
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof SaveCwsCategoryConvListService
   */
  execute(model: KYMW6802Model, vo: SaveCWSCategoryConvListModel, successFunc: Function = null) {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('saveCwsCategoryConvList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof SaveCwsCategoryConvListService
   */
  success(data: any) {
    if (data !== null) {
      this.model.updateFileName(data);
    }
    if (this.successFunc !== null) {
      this.successFunc(data);
    }
  }

}
